import { generate } from "shortid";
import { TARGET_DATA } from "../../../forms";
import { PAGE_TYPES, PAGE_THEMES } from "../../types";

export const PARENT_PROGRAM_PAGES = {
  parent_program_category_page: {
    id: `program_category_page-${generate()}`,
    type: PAGE_TYPES.category,
    custom_back: "parent_child_gender_select_page",
    backwards_navigation_enabled: true,
    title: null,
    module_name: "premium_program",
    target_state: TARGET_DATA.program,
    target_field: null,
    target_pages: [],
    component_type: null,
    theme: PAGE_THEMES.MELLOW,
    data: {
      title: "Your personalized program",
      description: null,
      image: "illustrations/winking-face",
      continue_button_label: "Continue",
      default_progression: "parent_program_clinical_lesson_page",
      options: [],
    },
  },
  parent_program_clinical_lesson_page: {
    id: `program_clinical_lesson_page-${generate()}`,
    type: PAGE_TYPES.step,
    backwards_navigation_enabled: true,
    title: "Your personalized program",
    module_name: "premium_program",
    target_state: TARGET_DATA.program,
    target_field: null,
    component_type: null,
    theme: PAGE_THEMES.LIGHT,
    data: {
      title: null,
      description: "oVRcome is all about doing a little bit, often.",
      image: "team",
      custom_back: null,
      default_progression: "parent_program_exposure_lesson_page",
      options: [
        {
          id: `step-item-1-${generate()}`,
          label: "In your first week",
          value: null,
          target_field: null,
          to: null,
          icon: "__deprecated/program-white",
          text: "Learn from psychologists",
          description:
            "Our clinical psychologists have developed audio lessons, exercises, and tools to make learning easy, applicable, and effective.\n\nMeet our team of experts:",
          isActive: true,
        },
      ],
    },
  },
  parent_program_exposure_lesson_page: {
    id: `program_exposure_lesson_page-${generate()}`,
    type: PAGE_TYPES.step,
    backwards_navigation_enabled: true,
    title: "Your personalized program",
    module_name: "premium_program",
    target_state: TARGET_DATA.program,
    target_field: null,
    component_type: null,
    theme: PAGE_THEMES.LIGHT,
    data: {
      title: null,
      description: "oVRcome is all about doing a little bit, often.",
      image: "illustrations/program-vr-plan",
      custom_back: null,
      default_progression: "parent_program_life_lesson_page",
      options: [
        {
          id: `step-item-1-${generate()}`,
          label: "In your first week",
          value: null,
          target_field: null,
          to: null,
          icon: "program",
          text: "Clinical lessons",
          description:
            "Our clinical psychologists have developed audio lessons, exercises, and tools for you make learning easy, applicable, and effective. Meet our team of experts:",
          isActive: false,
        },
        {
          id: `step-item-2-${generate()}`,
          label: "In 2+ weeks",
          value: null,
          target_field: null,
          to: null,
          icon: "__deprecated/vr-white",
          text: "VR exposure therapy",
          description:
            "Once you’ve received your VR headset watch simulations repeatedly, the exposure desensitizes you.",
          isActive: true,
        },
      ],
    },
  },
  parent_program_life_lesson_page: {
    id: `program_life_lesson_page-${generate()}`,
    type: PAGE_TYPES.step,
    backwards_navigation_enabled: true,
    title: "Your personalized program",
    module_name: "premium_program",
    target_state: TARGET_DATA.program,
    target_field: null,
    component_type: null,
    theme: PAGE_THEMES.LIGHT,
    data: {
      title: null,
      description: "oVRcome is all about doing a little bit, often.",
      image: "illustrations/track-progress",
      custom_back: null,
      default_progression: "parent_program_how_vr_works_page",
      options: [
        {
          id: `step-item-1-${generate()}`,
          label: "In your first week",
          value: null,
          target_field: null,
          to: null,
          icon: "program",
          text: "Clinical lessons",
          description:
            "Our clinical psychologists have developed audio lessons, exercises, and tools for you make learning easy, applicable, and effective. Meet our team of experts:",
          isActive: false,
        },
        {
          id: `step-item-2-${generate()}`,
          label: "In 2+ weeks",
          value: null,
          target_field: null,
          to: null,
          icon: "vr",
          text: "VR exposure therapy",
          description:
            "Once you’ve received your VR headset watch simulations repeatedly, the exposure desensitizes you. Progress to higher intensity simulations and conquer them!",
          isActive: false,
        },
        {
          id: `step-item-3-${generate()}`,
          label: "In 10+ weeks",
          value: null,
          target_field: null,
          to: null,
          icon: "__deprecated/reports-white",
          text: "Consistent, lifelong impact",
          description:
            "Track your improvement confronting fears and overcoming avoidance in the real world.",
          isActive: true,
        },
      ],
    },
  },
  parent_program_how_vr_works_page: {
    id: `program_how_vr_works_page-${generate()}`,
    type: PAGE_TYPES.summary,
    backwards_navigation_enabled: true,
    title: "Your personalized program",
    module_name: "premium_program",
    target_state: TARGET_DATA.program,
    target_field: null,
    component_type: null,
    theme: PAGE_THEMES.LIGHT,
    data: {
      title: "How does VR work?",
      description:
        "We’ll send you a VR headset so you can use your phone to experience VR simulations.  Right to your door. Anywhere in the world.",
      image: "illustrations/winking-face",
      custom_back: null,
      default_progression: "parent_program_monitor_child_progress_page",
      options: [
        {
          id: `image-item-1-${generate()}`,
          label: "Insert your mobile phone into the provided headset.",
          value: null,
          target_field: null,
          to: null,
          icon: "vr-headset",
          text: null,
          description: null,
          isActive: false,
        },
        {
          id: `image-item-2-${generate()}`,
          label: "Pop it on your head and start watching.",
          value: null,
          target_field: null,
          to: null,
          icon: "vr-headset-on-girl",
          text: null,
          description: null,
          isActive: false,
        },
      ],
    },
  },
  parent_program_exposure_therapy_page: {
    id: `program_exposure_therapy_page-${generate()}`,
    type: PAGE_TYPES.summary,
    backwards_navigation_enabled: true,
    title: "Your personalized program",
    module_name: "premium_program",
    target_state: TARGET_DATA.program,
    target_field: null,
    component_type: null,
    theme: PAGE_THEMES.LIGHT,
    data: {
      title: "Exposure therapy personalized to you",
      description:
        "Learn how to calm anxiety. We guide you through VR sessions designed to provoke a safe level of anxiety.",
      image: null,
      custom_back: null,
      default_progression: "parent_program_monitor_child_progress_page",
      options: [
        {
          id: `image-item-1-${generate()}`,
          label: null,
          value: null,
          target_field: null,
          to: null,
          icon: "illustrations/personalised",
          text: null,
          description: null,
          isActive: false,
        },
      ],
    },
  },
  parent_program_monitor_child_progress_page: {
    id: `parent_program_monitor_child_progress_page-${generate()}`,
    type: PAGE_TYPES.summary,
    backwards_navigation_enabled: true,
    title: "Your personalized program",
    module_name: "parent_program",
    target_state: TARGET_DATA.program,
    target_field: null,
    component_type: null,
    theme: PAGE_THEMES.LIGHT,
    data: {
      title: "Monitor your child's progress",
      description:
        "Login to a web dashboard to download your child’s workbook and watch live streaming sessions to see what your child is seeing in VR.",
      image: "illustrations/winking-face",
      custom_back: null,
      default_progression: "parent_program_celebrate_page",
      options: [
        {
          id: `image-item-1-${generate()}`,
          label: null,
          value: "large",
          target_field: null,
          to: null,
          icon: "on-laptop",
          text: null,
          description: null,
          isActive: false,
        },
      ],
    },
  },
  parent_program_celebrate_page: {
    id: `program_celebrate_page-${generate()}`,
    type: PAGE_TYPES.details,
    backwards_navigation_enabled: true,
    title: "Your personalized program",
    module_name: "premium_program",
    target_state: TARGET_DATA.program,
    target_field: null,
    target_pages: [],
    component_type: null,
    theme: PAGE_THEMES.LIGHT,
    data: {
      title: "You’re in good hands",
      description: "86.5%",
      image: null,
      custom_back: null,
      default_progression: "web_payment_setup_account_page",
      options: [
        {
          id: `extra-content-1-${generate()}`,
          label: "of people using oVRcome experienced a reduction in anxiety.",
          value: null,
          target_field: null,
          to: null,
          icon: "orgs/uoo",
          text: "*Lacey, C., Frampton, C., & Beaglehole, B. (2022). oVRcome – Self-guided virtual reality for specific phobias: A randomised controlled trial. Australian & New Zealand Journal of Psychiatry, 000486742211107. https:// doi.org/10.1177/00048674221110779",
          description: "Proven in a controlled clinical trial",
          isActive: false,
        },
      ],
    },
  },
};
